import React from 'react'
import styles from './BusinessRelease.module.css'
import BreadCrum from '../../BreadCrum/BreadCrum'

const BusinessRelease = () => {
  return (
    <>
      <BreadCrum/>
      <section className={styles.hero}>
      <div className={styles.left}>
        <span className={styles.badge}>Business</span>

        <h1 className={styles.title}>
          Businesswire Press Release 
          on FDA Approval
        </h1>

        <div className={styles.divider}></div>

        <div className={styles.meta}>
          <div className={styles.author}>
            <img
              src="/svg/marcus_johnson.svg"
              alt="Author"
              className={styles.avatar}
            loading="lazy" decoding="async" />
            <span>Marcus Johnson</span>
          </div>

          <span className={styles.date}>April 18, 2025</span>

          <a href="/" className={styles.readTime}>
            5 min read
          </a>
        </div>
      </div>

      <div className={styles.right}>
        <img
          src="Images/press_release.webp"
          alt="Press Release"
          className={styles.heroImage}
        loading="lazy" decoding="async" />
      </div>
    </section>
    </>
  )
}

export default BusinessRelease
